import { useContext } from 'react';
import { CopilotChannelContext } from '../channel/CopilotChannelContext';
export const useCopilotAppContext = () => {
  const {
    channelState
  } = useContext(CopilotChannelContext);

  // Have to return an empty object here in case it's undefined because the
  // channel state might be using an older version of the channel
  return channelState.appContext || {};
};